export default __webpack_public_path__ + "static/240-6ec1c706f04a9b43cd8f255b499b1a69.gif";